import {
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    Filler,
    Title,
    Legend
} from "chart.js";
Chart.register(BarController, BarElement, LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Title, Legend);

const chartsColors = [
    { borderColor: '#d84921', backgroundColor: '#d84921', transparencyColor: '#f7dad3' },
    { borderColor: '#999', backgroundColor: '#999', transparencyColor: '#e4cdc7' },
]

export default {
    // called before bound element's attributes
    // or event listeners are applied
    created(el, binding, vnode, prevVnode) {
        let canvas = document.createElement('canvas');
        if(binding.value.height) {
            canvas.height = binding.value.height;
        }
        if(binding.value.width) {
            canvas.width = binding.value.width;
        }
        el.appendChild(canvas);
        let table = el.querySelector('table');
        if(!table) {
            return;
        }
        let title = table.querySelector('caption');
        let rows = Array.from(table.querySelectorAll('tbody th'));
        let columns = Array.from(table.querySelectorAll('thead th'));
        let datasets = rows.map((row, index) => {
            let chartDef = {
                data: [],
                label: row.textContent,
                borderColor: chartsColors[index].borderColor,
                backgroundColor: chartsColors[index].transparencyColor,
                fill: 'origin'
            };
            let cells = Array.from(row.parentElement.querySelectorAll('td'));
            cells.forEach(cell => {
                chartDef.data.push( parseFloat(cell.textContent) );
            });
            return chartDef;
        });
        table.style.display = 'none';
        if(datasets.length > 1) {
            datasets = datasets.sort((a, b) => {
                return a.data.reduce((acc, v) => acc + v, 0) - b.data.reduce((acc, v) => acc + v, 0);
            });
        }
        let chartInstance = null;

        let ch = new Chart(canvas, {
            type: binding.value.type,
            data: {
                labels: columns.map(c => c.textContent),
                datasets
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio: 4/3,
                scales: {
                    y: {
                        stacked: false,
                        beginAtZero: true,
                        grid: {
                            display: true
                        },
                        display: true,
                    },
                    x: {
                        grid: {
                            display: false
                        }
                    }
                },
                plugins: {
                    filler: {
                        propagate: false
                    },
                    title: {
                        display: true,
                        text: title.textContent,
                    },
                    legend: {
                        display: true
                    },
                }
            },
        })

        const resizeHandler = () => {
            if (ch) {
              ch.resize();
            }
        };
        window.addEventListener('resize', resizeHandler);

        el._chartResizeHandler = resizeHandler;
    },
    // called right before the element is inserted into the DOM.
    beforeMount(el, binding, vnode, prevVnode) {},
    // called when the bound element's parent component
    // and all its children are mounted.
    mounted(el, binding, vnode, prevVnode) {},
    // called before the parent component is updated
    beforeUpdate(el, binding, vnode, prevVnode) {},
    // called after the parent component and
    // all of its children have updated
    updated(el, binding, vnode, prevVnode) {},
    // called before the parent component is unmounted
    beforeUnmount(el, binding, vnode, prevVnode) {},
    // called when the parent component is unmounted
    unmounted(el, binding, vnode, prevVnode) {
        window.removeEventListener('resize', el._chartResizeHandler);
    }
}
